import React from 'react';
import { HelpCircle, Loader2 } from 'lucide-react';
import { CIEN_CUADRAS_BUTTON_BLUE } from '../../../constants';

interface ProfileConfirmSaveModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export const ProfileConfirmSaveModal: React.FC<ProfileConfirmSaveModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-xs z-[250] flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-white rounded-2xl sm:rounded-3xl shadow-2xl max-w-sm w-full p-6 text-center border border-gray-100 animate-fade-in-up">
        <div className="w-14 h-14 rounded-2xl bg-sky-50 text-sky-600 flex items-center justify-center mx-auto mb-4 border border-sky-100 shadow-xs">
          <HelpCircle className="w-8 h-8 stroke-[2.2]" />
        </div>

        <h3 className="text-base sm:text-lg font-black text-gray-800 uppercase tracking-tight mb-2">
          ¿Guardar cambios?
        </h3>

        <p className="text-xs sm:text-sm text-slate-600 font-medium leading-relaxed mb-6">
          ¿Realmente deseas guardar las modificaciones realizadas en tu perfil? Tus datos se actualizarán en el sistema.
        </p>

        <div className="flex gap-3">
          <button
            type="button"
            disabled={loading}
            onClick={onCancel}
            className="flex-1 py-2.5 px-4 rounded-xl border border-gray-200 text-xs font-black uppercase tracking-wider text-gray-500 hover:bg-gray-50 active:scale-95 transition-all cursor-pointer disabled:opacity-50"
          >
            Cancelar
          </button>
          <button
            type="button"
            disabled={loading}
            onClick={onConfirm}
            className="flex-1 py-2.5 px-4 rounded-xl text-white text-xs font-black uppercase tracking-wider shadow-md hover:opacity-95 active:scale-95 transition-all flex items-center justify-center gap-1.5 cursor-pointer disabled:opacity-50"
            style={{ backgroundColor: CIEN_CUADRAS_BUTTON_BLUE }}
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                <span>Guardando...</span>
              </>
            ) : (
              <span>Sí, guardar</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
